module.exports = __webpack_public_path__ + "img/consultor-digital.34dda12f.svg";